import { render, staticRenderFns } from "./standart-category-list.vue?vue&type=template&id=1a1c65fe&"
import script from "./standart-category-list.vue?vue&type=script&lang=ts&"
export * from "./standart-category-list.vue?vue&type=script&lang=ts&"
import style0 from "./standart-category-list.vue?vue&type=style&index=0&id=1a1c65fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports